import { ApplicationActivity } from "../types";
import { Show } from "shared/components";

interface LandlordSurveyViewProps {
  activityItem: ApplicationActivity;
}

export const LandlordSurveyView = ({
  activityItem
}: LandlordSurveyViewProps) => {
  if (
    typeof activityItem.details !== "object" ||
    !activityItem.details.rental_verification_survey
  )
    return null;

  const survey = activityItem.details.rental_verification_survey;

  return (
    <div className="mt-2">
      <Show if={activityItem.activity_type === "landlord_survey_manual_resent"}>
        <Show if={survey.old_landlord_name}>
          <p className="text-sm font-normal text-content-400">
            Previous landlord&apos;s name {survey.old_landlord_name}→ New
            landlord&apos;s name {survey.landlord_name}
          </p>
        </Show>
        <Show if={survey.old_landlord_email}>
          <p className="text-sm font-normal text-content-400">
            Previous email {survey.old_landlord_email}→ New email{" "}
            {survey.landlord_email}
          </p>
        </Show>
      </Show>
      <p className="text-sm font-normal text-content-400">
        {survey.landlord_name} {survey.landlord_email} was emailed a survey to
        verify {survey.applicant_name}&apos;s (
        {activityItem.details.applicant_role}) rental history.
      </p>
      <Show if={activityItem.activity_type.includes("nudge")}>
        <p className="text-sm font-normal text-content-400">
          Reminder {survey.nudge_times} of 3
        </p>
      </Show>
    </div>
  );
};
